import { useEffect, useState } from 'react';
import { T } from '../i18n';
import { urlApi } from '../api/config';

/**
 * La marque affichee dans le logiciel.
 *
 * C'est le nom de l'AGENCE, pas celui du produit : une agence ouvre son outil
 * et doit y voir son enseigne. Il vient des parametres, comme l'en-tete du
 * contrat, et ne peut donc pas diverger de ce qui s'imprime.
 *
 * Le dernier mot passe en petit sous les autres — « FRIENDS » au-dessus,
 * « LOCATION » en dessous — ce qui garde la silhouette du logo quelle que soit
 * la raison sociale saisie.
 *
 * Tant que rien n'est charge, on n'affiche RIEN plutot qu'un nom par defaut :
 * une agence ne doit jamais voir clignoter le nom d'une autre.
 */
export interface Marque { principal: string; secondaire: string }

let cache: Marque | null = null;

export function useMarque(): Marque | null {
  const [marque, setMarque] = useState<Marque | null>(cache);
  useEffect(() => {
    if (cache) return;
    let vivant = true;
    fetch(urlApi('/api/auth/identite'))
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { marque?: string } | null) => {
        const mots = (d?.marque ?? '').trim().split(/\s+/).filter(Boolean);
        if (!mots.length || !vivant) return;
        cache = {
          principal: mots.length > 1 ? mots.slice(0, -1).join(' ') : mots[0]!,
          secondaire: mots.length > 1 ? mots[mots.length - 1]! : '',
        };
        setMarque(cache);
        document.title = T.app.titreDocument(mots.join(' '));
      })
      .catch(() => {});
    return () => { vivant = false; };
  }, []);
  return marque;
}
